export const CONFIGURATION_CHANGED = 'table_model.CONFIGURATION_CHANGED'
export const PAGINATION_CHANGED = 'table_model.PAGINATION_CHANGED'
